module.exports = __webpack_public_path__ + "img/0Q3A8493_L_WoodMatted_MockedUp.01661115.jpg";